// The first integration outside /onboarding: the rail's pill and panel, the
// status pill over every page, Home's banner and the build card.

export const firstIntegrationTestIds = {
  railPill: 'first-integration-rail-button',
  railPillCount: 'first-integration-rail-count',
  panel: 'first-integration-panel',
  panelCount: 'first-integration-panel-count',
  panelClose: 'first-integration-panel-close-button',
  step: (id: string) => `first-integration-step-${id}-panel` as const,
  continueSetup: (where: string) => `first-integration-continue-${where}-button` as const,
  copySnippet: 'first-integration-copy-snippet-button',
  aiTools: 'first-integration-ai-tools-button',
  researchPill: 'first-integration-research-status',
  researchView: 'first-integration-research-view-button',
  researchReadyPill: 'first-integration-research-ready-status',
  notFinishedBanner: 'first-integration-not-finished-banner',
  buildCard: 'first-integration-build-card',
  buildCardOpen: 'first-integration-build-open-button',
  buildCardQuestion: 'first-integration-build-question-button',
  builtCard: 'first-integration-built-card',
  buildFailedCard: 'first-integration-build-failed-card',
  buildFailedOpen: 'first-integration-build-failed-open-button',
  builtLater: 'first-integration-built-later-button',
  builtContinue: 'first-integration-built-continue-button',
  customersWaiting: 'first-integration-customers-waiting-status',
  productCard: 'settings-general-product-card',
  productCardContinue: 'settings-general-product-continue-button',
} as const;
